// --------------------------user------------------------------------
const authRouteFormatter = (url) => `authAtheneum/${url}`;

export const getUsers = () => authRouteFormatter('');
export const createUser = () => authRouteFormatter('');
export const deleteUser = (id) => authRouteFormatter(`${id}`);
export const getOneUsers = (id) => authRouteFormatter(`${id}`);
// -----------------------------cart---------------------------------
const athCartRouteFormatter = (url) => `cart/${url}`;

export const getCart = () => athCartRouteFormatter('');
export const addItemToCart = () => athCartRouteFormatter('add');
export const getCartByUser = (id) => athCartRouteFormatter(`userId/${id}`);
export const deleteCart = (id) => athCartRouteFormatter(`${id}`);

// --------------------------user------------------------------------
const athProgramRouteFormatter = (url) => `programs/${url}`;

export const getPrograms = () => athProgramRouteFormatter('');
export const createProgram = () => athProgramRouteFormatter('');
export const deleteProgram = (id) => athProgramRouteFormatter(`${id}`);
export const getOneProgram = (id) => athProgramRouteFormatter(`${id}`);

// -----------------------------course-------------------------------
const athCourseRouteFormatter = (url) => `courses/${url}`;

export const getCourses = () => athCourseRouteFormatter('');
export const createCourse = () => athCourseRouteFormatter('');
export const updateCourse = (id) => athCourseRouteFormatter(`${id}`);
export const deleteCourse = (id) => athCourseRouteFormatter(`${id}`);
export const getOneCourse = (id) => athCourseRouteFormatter(`${id}`);

// -----------------------------offer-------------------------------
const athOfferRouteFormatter = (url) => `offer/${url}`;

export const getOffers = () => athOfferRouteFormatter('');
export const getOffersDetails = (id) => athOfferRouteFormatter(id);
export const getUserDetails = (id) => athOfferRouteFormatter('users');
export const createOffer = () => athOfferRouteFormatter('');
export const updateOfferStatus = () =>
  athOfferRouteFormatter('updateOfferStatus');
export const deleteOffer = (id) => athOfferRouteFormatter(`${id}`);
export const getOneOffer = (id) => athOfferRouteFormatter(`${id}`);
export const updateOneOffer = (id) => athOfferRouteFormatter(`${id}`);

// -----------------------------wishlist--------------------------------
const athWishlistRouteFormatter = (url) => `wishlist/${url}`;

export const getWishlist = () => athWishlistRouteFormatter('');

// ------------------------------order----------------------------------
const athOrderRouteFormatter = (url) => `order/${url}`;

export const getOrder = () => athOrderRouteFormatter('all');
export const createOrder = () => athOrderRouteFormatter('');
export const deleteOrder = (id) => athOrderRouteFormatter(`${id}`);
export const getOneOrder = (id) => athOrderRouteFormatter(`${id}`);

// NEW ROUTES

export const athProgramsListRoute = () => 'category';
export const athProgramUpdateDeleteRoute = (id) => `category/${id}`;

export const athCoursesListRoute = () => 'product';
export const athCourseUpdateDeleteRoute = (id) => `product/${id}`;

export const athGetAllCartsRoute = () => 'cart';

// Training Certificate routes
export const createTrainingCertificateRoute = () => `/training-certificate`;

export const getAllTrainingCertificatesRoute = () => `/training-certificate`;

export const updateTrainingCertificateRoute = (id) =>
  `/training-certificate/${id}`;

export const deleteTrainingCertificateRoute = (id) =>
  `/training-certificate/${id}`;

export const searchTrainingCertificateRoute = () =>
  `/training-certificate/search`;
